import {
  Edit,
  CardActions,
  ListButton,
  RefreshButton,
  DeleteButton,
  translate
} from "react-admin";
import React from "react";

import ServiceForm from "./ServiceForm";

const ServiceTitle = ({ translate, record }) => {
  return (
    <span>
      {`${translate("service.service")}`} {record ? `"${record.name}"` : ""}
    </span>
  );
};

const Title = translate(ServiceTitle);

const Actions = ({ basePath, data, resource }) => (
  <CardActions>
    <ListButton basePath={basePath} />
    <DeleteButton basePath={basePath} record={data} resource={resource} />
    <RefreshButton />
  </CardActions>
);

export const ServiceEdit = props => (
  <Edit actions={<Actions />} title={<Title />} {...props}>
    <ServiceForm />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/service/ServiceEdit.js